

module.exports = __webpack_require__.stylable.create(
    "description2059507781",
    {"classes":{"root":"description2059507781__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    /*! ../node_modules/@wix/search-box-v2/dist/src/components/Description/Description.st.css */ 1326,
    null
);
